// v3.3.991 — رأس عمود عام بنمط جدول الحجوزات (ColumnHeaderMenu):
// سهم ⌄ يفتح قائمة: ترتيب تصاعدي/تنازلي + فلتر قيم متعدد (بحث + تحديد الكل) —
// الفرق عن الأصل: القيم تمرر كـ prop (فلترة محلية) بلا نداء API، وبلا إخفاء/نقل أعمدة.
import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown, FiSearch, FiArrowUp, FiArrowDown, FiFilter, FiCheck } from "react-icons/fi";

export default function GenericHeaderMenu({ label, colKey, sortBy, sortDir, onSort, values, activeFilter, onFilter, align = "center", color = "#475569", thStyle }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [dropLeft, setDropLeft] = useState(false);
  const [selected, setSelected] = useState([]);
  const ref = useRef();
  const filterable = Array.isArray(values) && values.length > 0 && onFilter;

  useEffect(() => { setSelected(activeFilter && activeFilter.length ? activeFilter : []); }, [activeFilter]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const handleOpen = () => {
    if (!open && ref.current) setDropLeft(ref.current.getBoundingClientRect().left < window.innerWidth / 2);
    setOpen(o => !o); setSearch("");
  };
  const isActive = sortBy === colKey;
  const hasFilter = (activeFilter || []).length > 0;
  const shown = (values || []).filter(v => String(v).toLowerCase().includes(search.toLowerCase()));
  const toggle = (v) => setSelected(prev => (prev.includes(v) ? prev.filter(x => x !== v) : [...prev, v]));

  return (
    // v3.4.000 — thStyle: تمرير ستايل الرأس الأصلي (لاصق/خلفية) حتى لا يفقده الجدول المضيف
    <th ref={ref} style={{ position: "relative", cursor: "pointer", userSelect: "none", padding: "10px 8px", textAlign: align, fontWeight: 700, color, whiteSpace: "nowrap", ...thStyle }}>
      <div style={{ display: "inline-flex", alignItems: "center", gap: 3 }} onClick={handleOpen}>
        <span>{label}</span>
        {isActive && (sortDir === "asc" ? <FiArrowUp size={10} /> : <FiArrowDown size={10} />)}
        {hasFilter ? <FiFilter size={10} style={{ color: "#2563eb" }} /> : <FiChevronDown size={10} style={{ opacity: 0.4 }} />}
        {hasFilter && (
          <span style={{ minWidth: 16, height: 16, borderRadius: "50%", background: "#2563eb", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 9, fontWeight: 700, flexShrink: 0 }}>
            {(activeFilter || []).length}
          </span>
        )}
      </div>

      {open && (
        <div style={{
          position: "fixed",
          top: ref.current ? ref.current.getBoundingClientRect().bottom + 2 : 0,
          ...(dropLeft
            ? { left: ref.current ? ref.current.getBoundingClientRect().left : 0 }
            : { right: ref.current ? window.innerWidth - ref.current.getBoundingClientRect().right : 0 }),
          zIndex: 99999, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8,
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)", padding: 8, minWidth: 220, direction: "rtl",
        }}>
          <button onClick={() => { onSort(colKey, "asc"); setOpen(false); }} style={menuBtn}><FiArrowUp size={12} /> ترتيب تصاعدي</button>
          <button onClick={() => { onSort(colKey, "desc"); setOpen(false); }} style={menuBtn}><FiArrowDown size={12} /> ترتيب تنازلي</button>

          {filterable && (
            <>
              <div style={{ borderTop: "1px solid #f1f5f9", margin: "4px 0" }} />
              <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "5px 8px", background: "#f8fafc", borderRadius: 5, marginBottom: 4 }}>
                <FiSearch size={12} color="#94a3b8" />
                <input value={search} onChange={e => setSearch(e.target.value)} onClick={e => e.stopPropagation()} placeholder="بحث في القيم..."
                  style={{ border: "none", outline: "none", background: "none", width: "100%", fontFamily: "inherit", fontSize: 12, padding: 2 }} />
              </div>
              <div style={{ display: "flex", gap: 6, marginBottom: 4, padding: "0 4px" }}>
                <button onClick={() => setSelected(shown.map(String))} style={{ ...smallBtn, color: "#2563eb" }}>تحديد الكل</button>
                <button onClick={() => setSelected([])} style={{ ...smallBtn, color: "#64748b" }}>إلغاء الكل</button>
              </div>
              <div style={{ maxHeight: 220, overflowY: "auto", borderTop: "1px solid #f1f5f9", paddingTop: 4 }}>
                {shown.length === 0 && <div style={{ padding: "8px 10px", color: "#94a3b8", fontSize: 12 }}>لا توجد نتائج</div>}
                {shown.map(v => {
                  const sv = String(v), isSel = selected.includes(sv);
                  return (
                    <label key={sv} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", cursor: "pointer", borderRadius: 4, background: isSel ? "#eff6ff" : "transparent" }}
                      onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = "#f8fafc"; }}
                      onMouseLeave={e => { if (!isSel) e.currentTarget.style.background = "transparent"; }}>
                      <div style={{ width: 16, height: 16, borderRadius: 3, border: isSel ? "none" : "1.5px solid #cbd5e1", background: isSel ? "#2563eb" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        {isSel && <FiCheck size={11} color="#fff" strokeWidth={3} />}
                      </div>
                      <input type="checkbox" checked={isSel} onChange={() => toggle(sv)} style={{ display: "none" }} />
                      <span style={{ fontSize: 12, color: isSel ? "#1e40af" : "#1e293b", fontWeight: isSel ? 600 : 400 }}>{sv}</span>
                    </label>
                  );
                })}
              </div>
              <div style={{ borderTop: "1px solid #f1f5f9", marginTop: 4, paddingTop: 8, display: "flex", gap: 6 }}>
                <button onClick={() => { onFilter(colKey, selected); setOpen(false); }}
                  style={{ flex: 1, padding: "7px 12px", border: "none", borderRadius: 6, background: "#2563eb", color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                  تطبيق {selected.length > 0 && `(${selected.length})`}
                </button>
                {hasFilter && (
                  <button onClick={() => { setSelected([]); onFilter(colKey, []); setOpen(false); }}
                    style={{ padding: "7px 12px", border: "1px solid #fca5a5", borderRadius: 6, background: "#fff", color: "#ef4444", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                    مسح
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </th>
  );
}

const menuBtn = {
  display: "flex", alignItems: "center", gap: 6, width: "100%",
  padding: "6px 10px", border: "none", background: "none",
  fontFamily: "inherit", fontSize: 12, cursor: "pointer", borderRadius: 4,
  textAlign: "right", color: "#1e293b",
};
const smallBtn = { padding: "3px 8px", border: "none", background: "none", fontFamily: "inherit", fontSize: 11, cursor: "pointer", borderRadius: 3, fontWeight: 600 };
